import React from 'react';
import MainInfoTracLayout from '../../../components/Layout/Main';
import Content from '../../../components/Pages/UserManagement/CreateRole';

function UserManagementCreateRole() {
  return (
    <MainInfoTracLayout className="min-h-[100vh] bg-white" isOldPage>
      <Content />
    </MainInfoTracLayout>
  );
}

export default UserManagementCreateRole;
